
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#ECEBF0"}}),_c('path',{attrs:{"d":"M16.1798 8.00313C13.7622 7.91494 11.7241 9.69865 11.5064 12.083C11.4421 12.786 11.9619 13.4075 12.6668 13.4715C13.3601 13.5264 13.9941 13.0181 14.0592 12.3143C14.1526 11.2877 15.0285 10.5023 16.0755 10.5572C17.0691 10.5971 17.9217 11.469 17.9376 12.4607C17.9492 13.1554 17.6014 13.786 17.0065 14.1496C15.5708 15.0248 14.7132 16.1098 14.7132 17.7221C14.7132 18.4276 15.2872 19 15.9946 19C16.702 19 17.276 18.4276 17.276 17.7221C17.276 17.0075 17.6748 16.7369 18.3438 16.3293C19.7003 15.5015 20.5271 14.0023 20.5004 12.4183C20.462 10.0788 18.524 8.09882 16.1798 8.00313Z","fill":"#10001F"}}),_c('path',{attrs:{"d":"M16 24C16.8284 24 17.5 23.3284 17.5 22.5C17.5 21.6716 16.8284 21 16 21C15.1716 21 14.5 21.6716 14.5 22.5C14.5 23.3284 15.1716 24 16 24Z","fill":"#10001F"}})])
          )
        }
      }
    